import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import localeDe from '@angular/common/locales/de';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { AuthInterceptorService } from '@core/auth';
import { createTranslateLoader, initializeAppFactory } from '@core/utils';
import { MockHttpInterceptor } from '@core/dev';
import {
  LocalizedCurrencyPipe,
  LocalizedDatePipe,
  LocalizedPercentagePipe,
  MwstUppercasePipe,
  ProviderImagePipe,
  TranslatePluralPipe,
  UrlPipe,
} from '@core/pipes';
import { AssetHashesService, LanguageService, ProviderSettingsService } from '@core/services';

registerLocaleData(localeDe);

@NgModule({
  declarations: [UrlPipe, TranslatePluralPipe, LocalizedDatePipe, LocalizedCurrencyPipe, MwstUppercasePipe, ProviderImagePipe, LocalizedPercentagePipe],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, AssetHashesService, ProviderSettingsService],
      },
    }),
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    BrowserAnimationsModule,
    MatIconModule,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    UrlPipe,
    TranslatePluralPipe,
    LocalizedDatePipe,
    LocalizedCurrencyPipe,
    LocalizedPercentagePipe,
    MwstUppercasePipe,
    ProviderImagePipe,
  ],
  providers: [
    UrlPipe,
    DatePipe,
    DecimalPipe,
    CurrencyPipe,
    TranslatePluralPipe,
    LocalizedDatePipe,
    LocalizedCurrencyPipe,
    LocalizedPercentagePipe,
    ProviderImagePipe,
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'EUR',
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MockHttpInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      multi: true,
      deps: [HttpClient, AssetHashesService, LanguageService, ProviderSettingsService],
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
  ],
})
export class CoreModule {}
